import MuiCardContent, { CardContentProps } from '@mui/material/CardContent';

export interface ICardContentProps extends CardContentProps { }

const CardContent = (props: ICardContentProps): JSX.Element => {
  return <MuiCardContent
    {...props}
    style={{ ...props.style, margin: 0, padding: 8 }}
    sx={{ ...props.sx }}
  />;
};

export default CardContent;
